import { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { sendContact, apiError } from "@/lib/api";
import Seo from "@/components/Seo";

const MOTIVOS = [
  "Información general", "Información sobre un libro", "Publicar con Harvest",
  "Distribución", "Prensa y comunicación", "Derechos editoriales", "Otro",
];

export default function Contacto() {
  const [form, setForm] = useState({ nombre: "", apellidos: "", email: "", pais: "", motivo: "", mensaje: "" });
  const [privacy, setPrivacy] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const inputCls = "w-full rounded-lg border border-[#0f2544]/15 bg-white px-4 py-3 text-sm outline-none focus:border-[#1f44e0] transition-colors";
  const labelCls = "block text-sm font-medium text-[#0f2544] mb-1.5";

  const submit = async (e) => {
    e.preventDefault();
    if (!privacy) return toast.error("Debes aceptar la Política de Privacidad.");
    setLoading(true);
    try {
      await sendContact(form);
      setSent(true);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Seo title="Contacto" description="Contacta con Editorial Harvest." />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-12 pt-16 pb-12">
        <div className="text-center">
          <p className="hv-overline">Contacto</p>
          <h1 className="font-serif text-4xl md:text-5xl text-[#0f2544] mt-3">Hablemos</h1>
          <p className="text-[#4a4a45] mt-4">Si deseas contactar con Editorial Harvest, completa el siguiente formulario.</p>
        </div>

        {sent ? (
          <div className="mt-12 text-center rounded-lg bg-[#eceae4] border border-[#0f2544]/10 py-16 px-6" data-testid="contact-confirmation">
            <CheckCircle2 size={48} className="mx-auto text-[#1f44e0]" />
            <h2 className="font-serif text-2xl text-[#0f2544] mt-5">Mensaje enviado</h2>
            <p className="text-[#4a4a45] mt-3">Gracias por escribirnos. Te responderemos lo antes posible.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 space-y-5" data-testid="contact-form">
            <div className="grid sm:grid-cols-2 gap-5">
              <div><label className={labelCls}>Nombre *</label><input required value={form.nombre} onChange={set("nombre")} className={inputCls} data-testid="ct-nombre" /></div>
              <div><label className={labelCls}>Apellidos</label><input value={form.apellidos} onChange={set("apellidos")} className={inputCls} data-testid="ct-apellidos" /></div>
            </div>
            <div className="grid sm:grid-cols-2 gap-5">
              <div><label className={labelCls}>Email *</label><input type="email" required value={form.email} onChange={set("email")} className={inputCls} data-testid="ct-email" /></div>
              <div><label className={labelCls}>País</label><input value={form.pais} onChange={set("pais")} className={inputCls} data-testid="ct-pais" /></div>
            </div>
            <div>
              <label className={labelCls}>Motivo *</label>
              <select required value={form.motivo} onChange={set("motivo")} className={inputCls} data-testid="ct-motivo">
                <option value="">Selecciona...</option>
                {MOTIVOS.map((m) => <option key={m} value={m}>{m}</option>)}
              </select>
            </div>
            <div><label className={labelCls}>Mensaje *</label><textarea required rows={5} value={form.mensaje} onChange={set("mensaje")} className={inputCls} data-testid="ct-mensaje" /></div>
            <label className="flex items-start gap-2.5 text-sm text-[#4a4a45] cursor-pointer">
              <input type="checkbox" checked={privacy} onChange={(e) => setPrivacy(e.target.checked)} className="accent-[#1f44e0] mt-0.5" data-testid="ct-privacy" />
              Acepto la Política de Privacidad.
            </label>
            <button type="submit" disabled={loading} className="w-full rounded-full bg-[#0f2544] px-8 py-4 text-xs font-semibold tracking-[0.12em] text-white hover:bg-[#1f44e0] transition-colors disabled:opacity-60" data-testid="ct-submit">
              {loading ? "ENVIANDO..." : "ENVIAR MENSAJE"}
            </button>
          </form>
        )}

        <div className="mt-14 text-center border-t border-[#0f2544]/10 pt-10">
          <p className="hv-overline">Dirección</p>
          <p className="text-[#4a4a45] mt-3 leading-relaxed">
            Harvest Books Ltd.<br />
            Rue de Vermont 9A<br />
            1202 Ginebra, Suiza
          </p>
        </div>
      </section>
    </>
  );
}
